var _rect, _g, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIntroText(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 160,
    viewBox: "0 0 320 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 304,
    height: 152,
    transform: "translate(8 8)",
    fill: "#A5B0B7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4160_81496)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 42.8569,
    width: 12,
    height: 12,
    fill: "#4C6170"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133,
    y: 42.8569,
    width: 110,
    height: 12,
    fill: "#4C6170"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 70.8569,
    width: 160,
    height: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 94.8569,
    width: 160,
    height: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 118.857,
    width: 160,
    height: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 53.9831C97.8884 53.7785 99.0687 53.4321 99.5408 52.944C100.013 52.4402 100.249 51.1413 100.249 49.0473V28.0997C100.249 26.3679 99.9814 25.2422 99.4464 24.7226C98.927 24.2031 97.7783 23.8803 96 23.7544V22.8569H109.431V23.7544C107.653 23.8803 106.496 24.2031 105.961 24.7226C105.426 25.2422 105.159 26.3679 105.159 28.0997V37.5226H119.818V28.0997C119.818 26.3679 119.558 25.2422 119.039 24.7226C118.519 24.2031 117.363 23.8803 115.569 23.7544V22.8569H129V23.7544C127.222 23.8803 126.065 24.2031 125.53 24.7226C125.011 25.2422 124.751 26.3679 124.751 28.0997V49.6141C124.751 51.3775 125.011 52.5111 125.53 53.0149C126.065 53.5029 127.222 53.8257 129 53.9831V54.8569H115.569V53.9831C117.473 53.7942 118.653 53.4478 119.109 52.944C119.582 52.4402 119.818 51.1413 119.818 49.0473V39.6481H105.159V49.6141C105.159 51.3775 105.426 52.5111 105.961 53.0149C106.496 53.5187 107.653 53.8414 109.431 53.9831V54.8569H96V53.9831Z",
    fill: "#4C6170"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 150.857,
    width: 304,
    height: 9.14286,
    fill: "#0056A4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4160_81496"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 117,
    fill: "white",
    transform: "translate(80 18.8569)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntroText);
export default __webpack_public_path__ + "static/media/intro-text.ac27e2c32ae56aa7c5f05be77aab6b37.svg";
export { ForwardRef as ReactComponent };